import { LocalStorageInformation, LocalSelectedCity } from './../app.component';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';


// key that is used to access the data in local storage 
const STORAGE_KEY_DATA_CURRENT_WEATHER = 'LocalDataCurrentWeather';
const STORAGE_KEY_DATA_FORECAST_WEATHER = 'LocalDataForecastWeather';
const STORAGE_KEY_SELECTED_CITY = 'LocalSelectedCity';
const STORAGE_KEY_DATA_SWIPE_HISTORY = 'SwipeHistory';




@Injectable()
export class LocalStorageService  {

  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService) { }

  // EASTER EGG
  public StoreSwipeHistory(index: number): boolean {
    
    let returnValue = false;
    const c = [3,7,8,0];
    let swipehist = this.GetSwipeHistory();
    if(swipehist == null)
    {
      swipehist = [] as number[];
    }
    swipehist.push(index); // append item
    
    //console.log(swipehist);

    if(swipehist != null && swipehist.length == 5 )
    {
      swipehist.shift(); // remove the first, creating FIFO array

      if(this.arrayEquals(swipehist, c))
      {
        this.storage.set(STORAGE_KEY_DATA_SWIPE_HISTORY, [] as number[]);
        return true;
      }
     

    }
    
    this.storage.set(STORAGE_KEY_DATA_SWIPE_HISTORY, swipehist);

    return returnValue;
}

public GetSwipeHistory(): number[] {

return this.storage.get(STORAGE_KEY_DATA_SWIPE_HISTORY);
}

  public storeCityCurrentWeatherToLocalStorage(cityWeatherInformation: LocalStorageInformation): void {
          this.storage.set(STORAGE_KEY_DATA_CURRENT_WEATHER + cityWeatherInformation.weather.city, cityWeatherInformation);
  }

  public getStoredCurrentWeatherInfoFromLocalStorage(city: string): LocalStorageInformation {

    return this.storage.get(STORAGE_KEY_DATA_CURRENT_WEATHER + city);
  }

  public storeCityForecastWeatherToLocalStorage(cityWeatherInformation: LocalStorageInformation): void {
    this.storage.set(STORAGE_KEY_DATA_FORECAST_WEATHER + cityWeatherInformation.weather.city, cityWeatherInformation);
}

public getStoredForecasttWeatherInfoFromLocalStorage(city: string): LocalStorageInformation {

return this.storage.get(STORAGE_KEY_DATA_FORECAST_WEATHER + city);
}


  public storeSelectedCityToLocalStorage(selectedCity: LocalSelectedCity): void {

    this.storage.set(STORAGE_KEY_SELECTED_CITY, selectedCity);

   // console.log(this.storage.get(STORAGE_KEY_SELECTED_CITY));
}

public getStoredSelectedCity(): LocalSelectedCity {

return this.storage.get(STORAGE_KEY_SELECTED_CITY) || [];
}


public arrayEquals(a, b) {
  return Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index]);
}

}

